import * as React from 'react';
import { SVGProps } from 'react';
import styled from 'styled-components';

const SVG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.15 1.7a1 1 0 0 1 1.6.8V3.51c-.587.016-1.255.486-1.518.721a2.491 2.491 0 0 0-.731 1.704v4c-.017.667.232 1.34.745 1.845.258.23.917.692 1.504.707V13.5a1 1 0 0 1-1.6.8l-3.4-2.55H4A2.75 2.75 0 0 1 1.25 9V7A2.75 2.75 0 0 1 4 4.25h.75l3.4-2.55Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.64 5.287a1 1 0 0 1 .011 1.415l-1.258 1.277 1.314 1.314a1 1 0 0 1-1.414 1.414L11.99 9.404l-1.277 1.298a1 1 0 1 1-1.426-1.404l1.289-1.308-1.283-1.283a1 1 0 0 1 1.414-1.414l1.272 1.272 1.247-1.267a1 1 0 0 1 1.414-.01Z"
      fill="#000"
    />
  </svg>
);

const StyledSvgSpeakerOff = styled(SVG)`
  font-size: ${props => (props.fontSize ? props.fontSize : '1.6rem')};
  color: ${({ color, theme }) =>
    color ? color : theme.colors.neutralColors.charcoal};
  vertical-align: middle;
  shape-rendering: inherit;
  transform: translate3d(0, 0, 0);
`;
export default StyledSvgSpeakerOff;
